import {Utils} from '@busuu/legacy-core';
import FormUtils from 'helpers/form-utils.js';
import RegistrationTracking from 'tracking/pages/tracking-register.js';

class PasswordVisibilityToggle {
    constructor() {
        this.togglePassword = null;
        this.inputPassword = null;
        this.showPasswordIcon = null;
        this.showPasswordIcon = null;
        this.hidePasswordIcon = null;

        this.onTogglePassword = this.onTogglePassword.bind(this);
        this.onPasswordInput = this.onPasswordInput.bind(this);

        this.initPasswordToggle();
    }

    initPasswordToggle() {
        this.inputPassword = Utils.getById('register-form-password');
        this.showPasswordIcon = Utils.getById('form-show-password-icon');
        this.togglePassword = Utils.getById('toggle-password');
        this.showPasswordIcon = Utils.getById('form-show-password-icon');
        this.hidePasswordIcon = Utils.getById('form-hide-password-icon');

        if (this.inputPassword) this.inputPassword.addEventListener('input', this.onPasswordInput);

        if (this.inputPassword && this.togglePassword) {
            this.togglePassword.addEventListener('click', this.onTogglePassword);
        }
    }

    onTogglePassword(e) {
        if (e) e.preventDefault();
        const isHidden = this.inputPassword.getAttribute('type') === 'password';
        const type = isHidden ? 'text' : 'password';
        this.inputPassword.setAttribute('type', type);
        FormUtils.toggleElement(this.showPasswordIcon, isHidden);
        FormUtils.toggleElement(this.hidePasswordIcon, !isHidden);
        if (isHidden) {
            RegistrationTracking.sendShowPasswordSelectedTracking();
        } else {
            RegistrationTracking.sendHidePasswordSelectedTracking();
        }
    }

    onPasswordInput() {
        return this.inputPassword.value
            ? Utils.removeClass(this.togglePassword, 'hidden')
            : Utils.addClass(this.togglePassword, 'hidden');
    }
}

export default PasswordVisibilityToggle;
